export default function btnCancelEvent(input, initialValue, actions, event, btnConfirm) {
  input.value = initialValue;
  if (input.classList.contains('has-error')) {
    input.classList.remove('has-error');
  }
  actions.classList.add('display--none');
  btnConfirm.classList.remove('display--none');

  const toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
  const parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ?
    event.target.parentElement.parentElement :
    event.target.parentElement.parentElement.parentElement;
  if (toolTip) {
    parentElement.removeChild(toolTip);
  }
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/events/btnCancelEvent.js